export default {
	message: {
		login: 'Log in',
		login_page_intro: 'Inventory Management',
		login_error: 'Username or password is incorrect.',
		active: 'Active',
		inactive: 'Inactive',
		email_address: 'Email address',
		password: 'Password',
		first_name: 'First name',
		last_name: 'Last name',
		user_role: 'User Role',
		status: 'Status',
		optional: 'Optional',
		selection: 'Selection',
		phone_number: 'Phone number',
		min_chars: 'Minimum {number} characters',
		date_created: 'Date created: {date}',
		date_registered: 'Date registered: {date}',
		date_modified: 'Date modified: {date}',
		edit_profile: 'Edit Profile',
		logout: 'Logout',
		dropdown_section_account: 'Account',
		orders_found: '{number} order(s) found',
		sku_found: '{number} SKU found',
		branches_found: '{number} branches found',
		items_found: '{number} items found',
		not_found_user_list: 'We didn’t find any users matching your criteria.',
		notFoundBranchList: 'We didn’t find any branches matching your criteria.',
		not_found_order_list: 'We didn’t find any orders matching your criteria.',
		notFoundSkuList: 'We didn’t find any skus matching your criteria.',
		notFoundErrorList: 'We didn’t find any errors matching your criteria.',
		password_format: 'Password should contain 8-32 characters, at least 1 upper case, at least 1 lower case and at least 1 number',
		days_left_change_pasword: 'You have ({number}) days left to change the password.',
		password_has_been_expired: 'Your password has been expired for ({number}) days.',
		channel_name: 'Channel name',
		maximum_characters: 'Maximum {number} characters',
		channel_type: 'Channel type',
		link_to_channel: 'Link to storefront channel',
		remark: 'Remark',
		online_stock_rule_info: 'Online stock rule info',
		allocation_rule_name: 'Rule name',
		priority: 'Priority',
		zero_is_highest_score_99_is_lowest_score: '1 is highest score, 99 is lowest score.',
		select_branch: 'Select branch',
		select_branches: 'Select branches',
		select_1_or_more_branch_to_apply_rule_to: 'Select 1 or more branch to apply rule to',
		there_is_no_branch_for_this_rule: 'There is no branch for this rule',
		thereIsNoSkuForThisRule: 'There is no sku for this rule',
		there_is_no_category_for_this_rule: 'There is no category for this rule',
		branches_can_select_more_than_1: 'Branch (can select more than 1)',
		skus_can_select_more_than_1: 'SKUs (can select more than 1)',
		selected_total: '{value} Selected',
		selected_branch_all: 'Selected branches all ({value})',
		selectedSkuAll: 'Selected SKU all ({value})',
		ratio_to_online_stock: 'Ratio to online stock',
		minimum_qty_for_branches: 'Minimum qty for branches',
		qty: 'Qty',
		select_sku_category: 'Select SKU/Category',
		set_rule_by: 'Set rule by',
		sku: 'SKU',
		skus: 'SKUs',
		selectSkus: 'Select SKUs',
		categories: 'Categories',
		categories_or_skus_is_required: 'Categories or SKUs is required',
		branches_is_required: 'Branches is required',
		available_for_categories: 'Select category',
		e_g_bangkok_area: 'e.g. Bangkok area',
		quantity_lower_than: 'Quantity lower than or equal',
		channel_rule_info: 'Channel rule info',
		rule_name: 'Rule name',
		allocate_to_channels: 'Allocate to channels',
		total_online_stock_qty: 'Total online stock qty: {value} qty',
		allocate_to: 'Allocate to',
		channels: 'Channels',
		allocation: 'Allocation',
		conditions: 'Conditions',
		there_is_no_condition_added: 'There is no condition added',
		condition: 'Condition',
		stock_will_allocate_to_channel: 'Stock will allocate to channel',
		not_found_data: 'Not found data',
		do_you_want_to_remove_this: 'Do you want to remove this?',
		do_you_want_to_update_order_status: 'Do you want to update order status?',
		the_status_will_update_to_ready_to_pickup: 'The status will update to <b>ready to pickup</b>',
		conditions_is_required: 'Conditions is required',
		for_online_group: 'For online group',
		select_group: 'Select group',
		allocation_is_required: 'Allocations is required',
		add_condition: 'Add condition',
		use_semicolon_to_input_multiple_items: 'Use semicolon (;) to input multiple items',
		no_sku_yet: 'No SKU yet',
		add_sku_number_in_order_to_set_condition: 'Add “SKU number” in order to set condition.',
		excludeSku: 'Exclude SKU',
		edit_sku: 'Edit SKU',
		notFoundAllocationChannels: 'There is no rule at the moment. Use create rule button to add new rule.',
	},
	button: {
		login: 'Log in',
		create: 'Create',
		create_user: 'Create new user',
		create_channel: 'Create channel',
		createAllocationRole: 'Create rule',
		cancel: 'Cancel',
		save_change: 'Save changes',
		filter: 'Filter',
		resetFilters: 'Reset search and filters',
		add_branch: 'Add branch',
		selectSkus: 'Add SKU',
		changeSkus: 'Edit SKU',
		select_categories: 'Add Categories',
		change_categories: 'Edit Categories',
		add_condition: 'Add condition',
		print: 'Print',
		remove: 'Remove',
		assign_branch: 'Assign branch',
		add: 'Add',
		close: 'close',
		syncAllocation: 'Sync allocation',
	},
	error: {
		required_field: 'Required field',
		min_length: 'Must be at least {number} characters',
		max_length: 'Must be less than {number} characters',
		min_value: 'Must be at least {number} value',
		max_value: 'Must be less than {number} value',
		email: 'Invalid email',
		url: 'Invalid URL',
	},
	toast: {
		success: 'Success!',
		created_user: 'New user has been created.',
		created_channel: 'New Channel has been created.',
		created_rule: 'New rule has been created.',
		update_rule: 'Your changes have been saved.',
		updated_channel: 'Your changes have been saved.',
		updated_profile: 'Your profile have been updated and you have to change your password every 90 days.',
		updated_user: 'Your changes have been saved.',
		unexpectedError: 'An unexpected error occurred. Please try again.',
		unable_to_save: 'Unable to save',
		error: 'Error',
		data_has_been_removed: 'This data has been deleted.',
		unable_to_remove: 'Unable to remove',
		update_order_status: 'Order status have been updated.',
		reSyncAllocationChannel: 'Allocation to channels is syncing. It could take up to 10 minutes for the result to take effect.',
	},
	placeholder: {
		stock_browser_sku: 'Search by SKU, product name, brand',
		stock_browser_branch: 'Search by branch ID, branch name and location',
		stock_browser_branch_detail: 'Search by SKU, product name or brand',
		stock_browser_sku_detail: 'Search by branch id or branch name',
		stock_online_stock: 'Search rule name',
		search_branch_id: 'Search branch id or name',
		search_sku_id: 'Search SKU id',
		sku_number: 'SKU number',
	},
	label: {
		brand: 'Brand',
		status: 'Status',
		product_type: 'Product Type',
		location: 'Location',
		branch: 'Branch',
		select_all: 'Select all',
		view_stock_qty: 'View stock qty',
		channel: 'Channel',
		payment: 'Payment method',
		shipment: 'Shipment',
		stock_rule: 'Online stock rule',
		channel_rule: 'Channel rule',
		errorStatus: 'Issue type',
		productStatus: 'Product status',
		eolStatus: 'EOL status',
		synced_with_thunder: 'Synced With Thunder',
	},
};
